import { slugify } from "./slugify";

const getContentLink = (
  x: number,
  y: number,
  zoom: number,
  contentSlug: string | undefined,
  mapSlug: string,
  title: string,
  withIntro: boolean = false
) => {
  const showIntroParam = withIntro ? 'showIntro=true&' : '';
  const screenWidth = window.innerWidth;
  const urlPath = withIntro ? `/map/${mapSlug}` : `/map/${mapSlug}/${slugify(title)}`;
  
  if (!contentSlug && screenWidth < 1000) {
    return `${urlPath}?${showIntroParam}x=${x - 10}&y=${y}&zoom=${zoom - 0.05}`;
  }
  return `${urlPath}?${showIntroParam}x=${x}&y=${y}&zoom=${zoom}`;
};

export default getContentLink;
